import React, { useState, useEffect} from 'react'
import { useParams, Link } from 'react-router-dom'
import trip_home_icon from '../../../assets/image/web-icons/home.png'
import './../../../css/main.css'
import { history } from '../../../functions/_helpers'
import Input from 'react-phone-number-input/input'
import {franchiseService} from '../../../functions/services'
import jwt from 'jwt-decode'
import { Alert } from '../../alerts'

const FranchiseEdit = ({props}) => {
   const { id }= useParams();

   const [submitted, setSubmitted] = useState(false);
   const [changes, setChanges] = useState(false);
   const [phoneValue, setPhoneValue] = useState();
   const [errors, setErrors] = useState(null);

   const [franchise, setFranchise] = useState({
      userId: 0,
      franchiseId: 0,
      name: '',
      email: '',
      phoneNumber: '',
      passwordWeb: '',
      deleted: false,
      permitHolders: [],
   });

   /* Check access rights. Only admin (1) is allowed */
   let user_data = JSON.parse(localStorage.getItem('user'))==null ?  [] : JSON.parse(localStorage.getItem('user'));
   if(user_data === null || user_data.length === 0)
   {
      localStorage.clear();
      history.push('/login');
   }

   // Check Role
   const decodedToken = jwt(user_data.token);
   if (decodedToken == null || decodedToken == undefined) {
         localStorage.clear();
         history.push('/login');
   }

   const role = parseInt(decodedToken.role);
   if(role !== 1){
      history.push('/');
   }


   useEffect(() => {
      // Load franchise
      if (id > 0) {
         franchiseService.getFranchise(id)
         .then(
            (response) => {
               setFranchise(response);
               setPhoneValue(response.phoneNumber);
            },
            (error) => {
               console.log(error);
            }
         )
      }
   }, []);


   function handleChange(e) {
      const { name, value } = e.target;
      setFranchise(franchise => ({ ...franchise, [name]: value }));
      setChanges(true);
   }

   function handleError(error){
      try {
         error = JSON.parse(error);
      }
      catch(ex){
         console.log(ex);
      }
      const errorText = error && error.message? error.message: `Det oppstod en feil. ${typeof error === 'string'? error: ''}`;
      setErrors(errorText);
   }


   function handleSubmit(e) {
      e.preventDefault();
      setSubmitted(true);
      setErrors(null);

      if(changes|| (franchise.phoneNumber !== phoneValue)) {
         franchise.phoneNumber = phoneValue

         if (id > 0) {
            franchiseService.putFranchise(franchise)
            .then(
            (response) => {
               history.push('/franchises');
            },
            (error) => {
               console.log(error);
               handleError(error);
            })
         }
         else {
            franchiseService.postFranchise(franchise)
            .then(
            (response) => {
               history.push('/franchises');
            },
            (error) => {
               console.log(error);
               handleError(error);
            })
         }
      }
   }


   const handleBack = () => {
      history.push('/franchises');
   }

   const closeError = () => {
      setErrors(null);
   }

   const getMenuText = function() {
      if (id == 0){
         return "LEGG TIL";
      }
      else {
         return "ENDRE";
      }
   }

   const getHeading = function() {
      if (id == 0){
         return "Ny franchise";
      }
      else {
         return "Endre franchise";
      }
   }

   return (
   <>
      <div className="calc-container w-full lg:space-x-2 space-y-2 lg:space-y-0 mb-2 lg:mb-4 top-adjustment custom-border-main">
         <div className="flex w-full trip_header ml-2">
            <div className="col-6 text-left">
               <img src={trip_home_icon} alt="home" />
               <span className="font-bold"> <Link to='/' className="non-undeline-link">HJEM &nbsp; &nbsp; / &nbsp; </Link></span>
               <span className="font-bold uppercase"> <Link to='/franchises' className="non-undeline-link">Franchiser &nbsp; &nbsp; / &nbsp;</Link> </span>
               <span className="font-bold"> {getMenuText()} &nbsp; &nbsp; / &nbsp; </span>
            </div>
            <div className="text-right inline-flex" style={{position:"absolute",right:"30px"}}>
               <button type="button" className="add_btn" id="backBtn" onClick={()=>handleBack()}> Tilbake </button>
            </div>
         </div>

         <div className="form-container">
            <form name="form" className="form flex flex-wrap w-full" onSubmit={handleSubmit} >
               <h4 className="trip_title font-bold mb-3"> {getHeading()} </h4>

               <>
                        {errors ? <div className="w-full mb-4">
                           <Alert
                           color="bg-transparent border-red-500 text-red-500 alert-error"
                           onClose={closeError}
                           borderLeft
                           raised>
                           {errors}
                           </Alert>
                        </div>: null}
                     </>

               <div className="page-content w-full trips drivers">
                  <div className="flex-4 form-container-column">
                     <label className="font-bold block"> Navn </label>
                     <input type="text" style={{border:"1px solid #37708e"}} name="name" value={franchise.name} onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} onChange={handleChange} className={'form-control' + (submitted && !franchise.name ? ' is-invalid' : '')} />
                     <label className="font-bold block"> Epost </label>
                     <input type="text" style={{border:"1px solid #37708e"}} name="email" value={franchise.email} onChange={handleChange} onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} className={'form-control' + (submitted && !franchise.email ? ' is-invalid' : '')} />
                     <label className="font-bold block"> Telefonnummer </label>
                     <Input className="form-control" style={{border:"1px solid #37708e"}}
                        name="phoneNumber"
                        value={phoneValue}
                        onChange={setPhoneValue} onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}/>
                  </div>

                  <div className="flex-4 form-container-column">
                     <label className="font-bold block"> Passord webportal</label>
                     <input type="password" style={{border:"1px solid #37708e"}} name="passwordWeb" value={franchise.passwordWeb} onChange={handleChange} onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} className={'form-control' + (submitted && !franchise.passwordWeb ? ' is-invalid' : '')} />

                     <label className="font-bold block"> Løyvehavere </label>
                     <div className="flex">
                        <div className="license_checkgroup" style={{overflowY:"scroll"}}>
                        {
                              franchise.permitHolders && franchise.permitHolders.map(item => (
                                 <div key={item.permitHolderId}>
                                    <div className="flex" style={{marginLeft:"10px"}}>
                                       <div className="permit-item">
                                          {item.company || (item.firstName + ' ' + item.lastName)}
                                       </div>
                                    </div>
                                 </div>
                              ))
                        }
                        </div>
                     </div>
                  </div>
               </div>
               <div className="driver_btns text-right mt-10" style={{float: "right",marginRight: "0px",height: "45px",margin: "30px auto"}}>
                  <button className="sign_btn"  style={{display:"inline", marginLeft:"30px"}} onClick={(e)=>handleBack(e)}> Avbryt </button>
                  <button className="sign_btn"  style={{display:"inline", marginLeft:"30px"}} onClick={(e)=>handleSubmit(e)}> Lagre </button>
               </div>
            </form>
         </div>
      </div>
   </>
   )
}
export default FranchiseEdit
